module.exports = __webpack_public_path__ + "10d4d8daf4c74ce636e19201d5a07d98.fbx";